import { useMutation } from "@apollo/client/react";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";
import GET_USERS from "../../queries/rolesAndPermissions/getUsers";
import { DELETE_GROUP } from "../../mutations/rolesAndPermissions/deleteGroup";

export const useDeleteGroup = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [deleteGroup, { data, loading, error }] = useMutation(DELETE_GROUP, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_USER_GROUPS, GET_USERS],
    awaitRefetchQueries: true,
  });

  return { deleteGroup, data, loading, error };
};
